exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body p[data-v-02b9071c]{margin:0 0 6px 0}[data-v-02b9071c] .el-input-number--medium{width:100%}[data-v-02b9071c] .el-input-number--medium .el-input__inner{text-align:left}.dialog-footer[data-v-02b9071c]{padding-top:20px}\n", ""]);

// exports
